import Vue from 'vue'
import VueI18n from 'vue-i18n'
import jaLocale from 'element-ui/lib/locale/lang/ja'
import ja from '@/locales/ja.json'

Vue.use(VueI18n)

const messages = {
  'ja-JP': {
    ...ja,
    ...jaLocale,
  },
}

const dateTimeFormats = {
  'ja-JP': {
    short: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
    },
    longEn: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: 'numeric',
      minute: 'numeric',
    },
    shortDate: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    shortWeekDay: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
    },
    shortMonthDate: {
      month: 'numeric',
      day: 'numeric',
    },
  },
}

const numberFormats = {
  'ja-JP': {
    currency: {
      style: 'currency',
      currency: 'JPY',
      currencyDisplay: 'name',
      minimumFractionDigits: 0,
      maximumFractionDigits: 4,
    },
    percent: {
      style: 'percent',
      useGrouping: false,
    },
    numeral: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 4,
    },
  },
}

const i18n = new VueI18n({
  locale: 'ja-JP',
  messages,
  fallbackLocale: 'ja-JP',
  dateTimeFormats,
  numberFormats,
})

export default i18n
